import { Expose } from 'class-transformer';

/**
 * Represents pharmacy address from PCC medications endpoint
 * Part of pharmacyInformation optional field on medications
 */
export class PccPharmacyAddress {
	/**
	 * Street address for the pharmacy
	 */
	addressLine1: string;

	/**
	 * Additional address information
	 */
	addressLine2: string;

	/**
	 * City
	 */
	city: string;

	/**
	 * State/Province
	 */
	state: string;

	/**
	 * Postal code
	 */
	postalCode: string;

	@Expose()
	get formatted(): string {
		return [this.addressLine1, this.city, this.state, this.postalCode].filter((val) => val).join(', ');
	}

	constructor(partial?: Partial<PccPharmacyAddress>) {
		Object.assign(this, partial);
	}
}

/**
 * Represents pharmacy information from PCC medications endpoint
 * Included when pharmacyInformation optional field is requested
 */
export class PccPharmacy {
	/**
	 * Unique identifier for the pharmacy
	 */
	pharmacyId: number;

	/**
	 * Name of the pharmacy
	 */
	pharmacyName: string;

	/**
	 * Phone number for the pharmacy
	 */
	phone: string;

	/**
	 * Fax number for the pharmacy
	 */
	fax: string;

	/**
	 * Pharmacy address
	 */
	address: PccPharmacyAddress;

	/**
	 * Primary contact person at the pharmacy
	 */
	primaryContact: string;

	@Expose()
	get displayName(): string {
		if (!this.primaryContact) return this.pharmacyName || '';
		return `${this.pharmacyName || ''}<br/>Primary Contact: ${this.primaryContact}`;
	}

	@Expose()
	get fullAddress(): string {
		return this.address?.formatted || '';
	}

	constructor(partial?: Partial<PccPharmacy>) {
		Object.assign(this, partial);
		if (this.address) this.address = new PccPharmacyAddress(this.address);
	}
}
